export default __webpack_public_path__ + "static/media/wn-6h.0e5b1857.png";